import { React, useState } from "react";
import Board from "./components/Board";

function App() {
	return (
		<div className="container">
			<Board />
		</div>
	);
}

export default App;
